import { URLS } from "@constants/urls";
import { STATUS } from "@constants/status.hrm";

import api from "@helpers/api";

const { PROMOTIONS, PROMOTION_DETAILS, RECOMMENDATIONS } = URLS;
const { SUCCESS, FAILED } = STATUS;

const apiEndPointBaseURL = `${process.env.REACT_APP_PROMOTION_SERVICE_URL}${process.env.REACT_APP_PROMOTION_SERVICE_PORT}/${process.env.REACT_APP_PROMOTION_SERVICE}/api/${process.env.REACT_APP_API_VERSION}/${process.env.REACT_APP_API_PRIVATE}/${PROMOTIONS}`;

export const initiateEmployeePromotion = (() => {
  return async (
    promotionId: number,
    promotionDetailsId: number,
    formData: any,
    afterEffect: (param: any) => void,
  ): Promise<{ data: any }> => {
    return api
      .put(
        `${apiEndPointBaseURL}/${promotionId}/${PROMOTION_DETAILS}/${promotionDetailsId}`,
        {
          ...formData,
        },
      )
      .then((response) => {
        afterEffect({
          data: response.data,
          status: SUCCESS,
        });

        return { data: response.data };
      })
      .catch((response) => {
        afterEffect({
          data: response.data,
          status: FAILED,
        });

        return { data: response.data };
      });
  };
})();

export const deleteEmployeePromotion = (() => {
  return async (
    promotionId: number,
    promotionDetailsId: number,
    afterEffect: (param: any) => void,
  ): Promise<{ data: any }> => {
    return api
      .delete(
        `${apiEndPointBaseURL}/${promotionId}/${PROMOTION_DETAILS}/${promotionDetailsId}`,
      )
      .then((response) => {
        afterEffect({
          data: response.data,
          status: SUCCESS,
        });

        return { data: response.data };
      })
      .catch((response) => {
        afterEffect({
          data: response.data,
          status: FAILED,
        });

        return { data: response.data };
      });
  };
})();

export const getPromotionById = (() => {
  //!!!
  return async (promotionID: string): Promise<{ data: any }> => {
    return api.get(`${apiEndPointBaseURL}/${promotionID}`).then((response) => {
      return { data: response.data };
    });
  };
})();

export const employeePromotionRecommendation = (() => {
  return async (
    promotionId: number,
    promotionDetailsId: number,
    formData: any,
    afterEffect: (param: any) => void,
  ): Promise<{ data: any }> => {
    return api
      .post(
        `${apiEndPointBaseURL}/${promotionId}/${PROMOTION_DETAILS}/${promotionDetailsId}/${RECOMMENDATIONS}`,
        {
          ...formData,
        },
      )
      .then((response) => {
        afterEffect({
          data: response.data,
          status: SUCCESS,
        });

        return { data: response.data };
      })
      .catch((response) => {
        afterEffect({
          data: response.data,
          status: FAILED,
        });

        return { data: response.data };
      });
  };
})();

export const updateEmployeePromotionRecommendation = (() => {
  return async (
    promotionId: number,
    promotionDetailsId: number,
    recommendationId: number,
    formData: any,
    afterEffect: (param: any) => void,
  ): Promise<{ data: any }> => {
    return api
      .put(
        `${apiEndPointBaseURL}/${promotionId}/${PROMOTION_DETAILS}/${promotionDetailsId}/${RECOMMENDATIONS}/${recommendationId}`,
        {
          ...formData,
        },
      )
      .then((response) => {
        afterEffect({
          data: response.data,
          status: SUCCESS,
        });

        return { data: response.data };
      })
      .catch((response) => {
        afterEffect({
          data: response.data,
          status: FAILED,
        });

        return { data: response.data };
      });
  };
})();
